// src/components/layout/Footer.jsx
//---------------------------------------------------------------
import { Container, Row, Col } from "react-bootstrap";
import {
    FaFacebookF, FaInstagram, FaTiktok,
    FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock
} from "react-icons/fa";
import { motion } from "framer-motion";
import { useTranslation } from "../../hooks/useTranslation";
import { NavLink } from "react-router-dom";

import "../../assets/styles/footer.css";
//---------------------------------------------------------------

export default function Footer() {
    const t = useTranslation();
    const yr = new Date().getFullYear();

    const fade = {
        hidden: { opacity: 0, y: 40 },
        show: { opacity: 1, y: 0, transition: { duration: .6, ease: [.22, .68, .17, 1] } }
    };

    return (
        <footer id="kapcsolat">
            <motion.div
                variants={fade} initial="hidden" whileInView="show"
                viewport={{ once: true, margin: "-50px" }}
                className="site-footer">

                <div className="footer-dark-wrapper">
                    <Container className="footer-container">

                        {/* ─────────────── 1st row — text cards ─────────────── */}
                        <Row className="footer-main g-3 g-lg-4 justify-content-center">
                            {/* Contact */}
                            <Col xs={12} lg={6} xl={4} className="footer-section">
                                <div className="glass-card footer-content-font">
                                    <h3 className="footer-heading">{t("footer.contactTitle")}</h3>
                                    <ul className="footer-list list-unstyled">
                                        <li className="footer-phone">
                                            <FaPhoneAlt className="footer-icon" />
                                            <a href="tel:+36304919340">+36 30 491 9340</a>
                                            <span className="footer-phone-separator">|</span>
                                            <a href="tel:+36309592613">+36 30 959 2613</a>
                                        </li>
                                        <li><FaEnvelope className="footer-icon" />
                                            <a href="mailto:roygym2024@gmail.com">roygym2024@gmail.com</a>
                                        </li>
                                    </ul>
                                </div>
                            </Col>

                            {/* Hours */}
                            <Col xs={12} lg={6} xl={4} className="footer-section">
                                <div className="glass-card footer-content-font">
                                    <h3 className="footer-heading">{t("footer.hoursTitle")}</h3>
                                    <ul className="footer-opening footer-list list-unstyled">
                                        <li><FaClock className="footer-icon" />{t("footer.hoursWeek")}</li>
                                        <li><FaClock className="footer-icon" />{t("footer.hoursWeekend")}</li>
                                    </ul>
                                </div>
                            </Col>

                            {/* Social */}
                            <Col xs={12} lg={6} xl={4} className="footer-section">
                                <div className="glass-card footer-content-font">
                                    <h3 className="footer-heading">{t("footer.followTitle")}</h3>
                                    <nav className="footer-social-links" aria-label="Social media">
                                        <a href="https://facebook.com/roygymfehervar"
                                            target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                            <FaFacebookF />
                                        </a>
                                        <a href="https://instagram.com/roygym_official"
                                            target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                            <FaInstagram />
                                        </a>
                                        <a href="https://tiktok.com/@roy_gym_official"
                                            target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                                            <FaTiktok />
                                        </a>
                                    </nav>
                                </div>
                            </Col>
                        </Row>

                        {/* ─────────────── 2nd row — map only ─────────────── */}
                        <Row className="footer-map-row g-3 justify-content-center mt-3">
                            <Col xs={12} md={10} lg={8} xl={6} className="footer-section">
                                <div className="glass-card-map map-card footer-content-font">
                                    <span className="map-badge"><FaMapMarkerAlt className="footer-icon" />{t("footer.address")}</span>

                                    <div className="map-wrapper">
                                        <iframe
                                            title="Roy Gym location"
                                            src="https://maps.google.com/maps?q=Budai%20%C3%9At%20154.%2C%20Sz%C3%A9kesfeh%C3%A9rv%C3%A1r%2C%20Hungary&z=15&output=embed"
                                            loading="lazy"
                                            allowFullScreen
                                            referrerPolicy="no-referrer-when-downgrade"
                                        />

                                        <noscript>
                                            <a href="https://maps.google.com/maps?q=Budai%20%C3%9At%20154.%2C%20Sz%C3%A9kesfeh%C3%A9rv%C3%A1r%2C%20Hungary&z=15">
                                                Térkép megnyitása a Google Térképen
                                            </a>
                                        </noscript>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {/* ─────────────── bottom bar ─────────────── */}
                        <Row className="footer-bottom text-center">
                            <Col>
                                <p className="footer-bottom-text mb-0">
                                    © {yr}&nbsp;Roy Gym&nbsp;|&nbsp;
                                    <NavLink to="/impresszum"
                                        end
                                        className="footer-impress-link">
                                        {t("footer.impresszumTitle")}
                                    </NavLink>
                                </p>
                                <p className="footer-credit-text mb-0">
                                    {t("footer.creditPrefix")}&nbsp;
                                    <a
                                        href="https://www.clarityworks.hu/"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        {t("footer.creditName")}
                                    </a>
                                </p>
                            </Col>
                        </Row>

                    </Container>
                </div>
            </motion.div>
        </footer>
    );
}
